<template>
  <div class="mySwiper warp">
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide>
        <img src="~@/assets/about/pic_1.jpg" />
        <p>企业服务类金奖</p>
      </swiper-slide>
      <swiper-slide>
        <img src="~@/assets/about/pic_2.jpg" />
        <p>最佳新经济公司奖项</p>
      </swiper-slide>
      <swiper-slide>
        <img src="~@/assets/about/pic_3.jpg" />
        <p>最佳SaaS公司</p>
      </swiper-slide>
      <swiper-slide>
        <img src="~@/assets/about/pic_4.jpg" />
        <p>最佳上市公司</p>
      </swiper-slide>
      <swiper-slide>
        <img src="~@/assets/about/pic_1.jpg" />
        <p>企业服务类金奖</p>
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      // modules: [EffectCoverflow, Pagination, Autoplay, Navigation],
      swiperOption: {
        effect: "coverflow",
        // grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 0,
          stretch: 1,
          scale: 1.14,
          depth: 345,
          modifier: 2.62,
          slideShadows: true,
        },
        autoplay: false,
        loop: true,
        loopedSlides: 2,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
};
</script>
<style lang="sass" scoped>

.mySwiper {
  position: relative;
  margin: 0 auto;
  margin-bottom:80px;
}
.mySwiper .swiper {
  padding-bottom: 80px;
}
.mySwiper .swiper-slide {
  width: 710px;
  background: #fff;
 box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.1000)
}
.swiper-button-prev,.swiper-button-next{
  color:#fff;
  background:rgba(0,0,0,.1);
  height:60px;
  width:60px;
  border-radius: 50%;

}
.swiper-button-next:hover,.swiper-button-prev:hover{
   background:rgba(0,0,0,.3);
}
.swiper-button-prev:after, .swiper-button-next:after{
  font-size:14px;
}
.mySwiper .swiper-slide img {
  display: block;
  width:100%
}
.mySwiper .swiper-slide p {
  line-height: 98px;
  padding-top: 0;
  text-align: center;
  color: #333;
  font-size: 26px;
  margin: 0;
}
::v-deep .swiper-container-3d .swiper-slide-shadow-right{
  background:none;
}
::v-deep .swiper-container-3d .swiper-slide-shadow-left{
  background:none;
}
.mySwiper .swiper-pagination {
  width: 100%;
  bottom: 0px;
}
::v-deep .swiper-pagination-bullet{
  width:43px;
  height:5px;
  border-radius: 2px !important;
}
.mySwiper .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 5px;
  border: 3px solid #fff;
  background-color: #d5d5d5;
  width: 10px;
  height: 10px;
  opacity: 1;
}

.mySwiper .swiper-pagination-bullets .swiper-pagination-bullet-active {
  border: 3px solid #00aadc;
  background-color: #fff;
}
</style>
